// styles
import styles from './image.module.scss'

type ImageProps = {
	readonly aspectRatio?: React.CSSProperties['aspectRatio']
} & React.ImgHTMLAttributes<HTMLImageElement>

const Image = (props: ImageProps): JSX.Element => {
	const { aspectRatio, alt, className, ...attr } = props

	return (
		<img
			{...attr}
			alt={alt || ''}
			className={[styles.image, className].join(' ').trim()}
			style={{ aspectRatio: aspectRatio }}
		/>
	)
}

export default Image
